import { render, staticRenderFns } from "./shop_goods.vue?vue&type=template&id=6c8ea4da&scoped=true"
import script from "./shop_goods.vue?vue&type=script&lang=js"
export * from "./shop_goods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8ea4da",
  null
  
)

export default component.exports